import { createReducer, on } from '@ngrx/store'
import { MapColorGeneratorActions } from './action-types'

const INIT_STATE: IMapColorGeneratorState = {
    colorMap: {},
    offset: 0
}

export const mapColorGeneratorReducer = createReducer(
    INIT_STATE,
    on(MapColorGeneratorActions.setColorMap, (state, {colorMap, colorOffset}): IMapColorGeneratorState =>
       ({...state, colorMap: colorMap, offset: colorOffset})
    ),
    on(MapColorGeneratorActions.resetColors, (): IMapColorGeneratorState => INIT_STATE),
)

export interface IMapColorGeneratorState {
    colorMap: any;
    offset: number;
}